var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcoingroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E7F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3366 16.0018V17.3351C23.3366 19.5443 20.0533 21.3351 16.0033 21.3351C12.0255 21.3351 8.78743 19.6076 8.67305 17.4531L8.66992 17.3351V16.0018C8.66992 18.211 11.9532 20.0018 16.0033 20.0018C20.0533 20.0018 23.3366 18.211 23.3366 16.0018ZM16.0033 10.6685C20.0533 10.6685 23.3366 12.4593 23.3366 14.6684C23.3366 16.8776 20.0533 18.6684 16.0033 18.6684C11.9532 18.6684 8.66992 16.8776 8.66992 14.6684C8.66992 12.4593 11.9532 10.6685 16.0033 10.6685Z",
    fill: "#1271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcoingroup);
export default __webpack_public_path__ + "static/media/icon.coin.group.10534753885a56606a7549d9464ffa2a.svg";
export { ForwardRef as ReactComponent };